jQuery(document).ready(() => {
  // Switch between light and dark mode
  $(".theme-switcher .light").click(function() {
    $("link#theme").attr("href", "assets/css/light.css");
  });

  $(".theme-switcher .dark").click(function() {
    $("link#theme").attr("href", "assets/css/dark.css");
  });

  // Add active class to topbar icons
  $(".theme-switcher .nav-item .nav-link").click(function() {
    $(".theme-switcher .nav-item").removeClass("active");
    $(this)
      .parent()
      .addClass("active");
  });

  $(".type-switcher .nav-item .nav-link").click(function() {
    $(".type-switcher .nav-item").removeClass("active");
    $(this)
      .parent()
      .addClass("active");
  });

  $(".results .btn-group a[data-toggle=collapse]").click(function() {
    $(this)
      .parents("li")
      .toggleClass("active");
  });

  // Prevent closing dropdown on click label
  $(document).on("click", ".dropdown-menu", function(e) {
    e.stopPropagation();
  });

  // Multiselect options
  // $('.filter-table select').multiselect({
  //     buttonText: function(options, select) {
  //         return 'Filter';
  //     },
  //     buttonTitle: function(options, select) {
  //         var labels = [];
  //         options.each(function () {
  //             labels.push($(this).text());
  //         });
  //         return labels.join(' - ');
  //     }

  // });

  $(".filter-table-search select").multiselect({
    enableFiltering: true,
    filterPlaceholder: "Zoeken...",

    buttonText: function(options, select) {
      return "Filter";
    },
    buttonTitle: function(options, select) {
      var labels = [];
      options.each(function() {
        labels.push($(this).text());
      });
      return labels.join(" - ");
    }
  });

  // Statistics slider
  $(".dashboard-slider").carousel({
    pause: true,
    interval: false
  });

  // Chartjs addon for showing percentage in center
  if (typeof Chart !== "undefined") {
    Chart.pluginService.register({
      beforeDraw: function(chart) {
        if (chart.config.options.elements.center) {
          //Get ctx from string
          var ctx = chart.chart.ctx;

          //Get options from the center object in options
          var centerConfig = chart.config.options.elements.center;
          var fontStyle = centerConfig.fontStyle || "Arial";
          var txt = centerConfig.text;
          var color = centerConfig.color || "#000";
          var sidePadding = centerConfig.sidePadding || 20;
          var sidePaddingCalculated =
            (sidePadding / 100) * (chart.innerRadius * 2);
          //Start with a base font of 30px
          ctx.font = "40px " + fontStyle;

          //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
          var stringWidth = ctx.measureText(txt).width;
          var elementWidth = chart.innerRadius * 2 - sidePaddingCalculated;

          // Find out how much the font can grow in width.
          var widthRatio = elementWidth / stringWidth;
          var newFontSize = Math.floor(30 * widthRatio);
          var elementHeight = chart.innerRadius * 2;

          // Pick a new font size so it will not be larger than the height of label.
          var fontSizeToUse = Math.min(newFontSize, elementHeight);

          //Set font settings to draw it correctly.
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
          var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
          ctx.font = fontSizeToUse + "px " + fontStyle;
          ctx.fillStyle = color;

          //Draw text in center
          ctx.fillText(txt, centerX, centerY);
        }
      }
    });
  }
});

jQuery(document).ready(() => {
  //Legend animation
  $(".legend").click(function() {
    $(this).toggleClass("open", 1000);
  });
});
